/**
 *  Copyright AlpineReplay Inc, 2021. All rights reserved.
 *  Authors: Brian Bal, Leonid Khramov
 */
import React, { Component } from 'react'
import { withRouter } from 'react-router'

import './TeamRoleSetter.css'

class TeamRoleSetterComponent extends Component {

    constructor(props) {
        super(props)

        this.onRadioChange = this.onRadioChange.bind(this)
        this.onResetMember = this.onResetMember.bind(this)
    }

    onResetMember(e) {
        if (e) { e.preventDefault() }

        const vals = e.currentTarget.id.split('-')

        if(this.props.onRoleChanged) {
            this.props.onRoleChanged(vals[1], vals[0])
        }
    }
    
    onRadioChange(e) {
        const vals = e.target.id.split('-')

        console.log('TeamRoleSetter.onRadioChange', e, this.props)
        if(this.props.onRoleChanged) {
            this.props.onRoleChanged(vals[1], vals[0])
        }
    }

    getRadioButton(selected, group, id) {
        return (
            <input
                key={id}
                id={id}
                className="radio-button"
                type="radio"
                name={group}
                onChange={this.onRadioChange}
                checked={selected}
            />
        )
    }

    render() {
        console.log('TeamRoleSetter', this.props)
        const miniTitle = this.props.miniTitle ? this.props.miniTitle : 'Roles'
        const description = this.props.description ? this.props.description : 'Only coaches and managers will receive email alerts when this team\'s games have been uploaded.'
        return (
            <div className="TeamRoleSetter">
                <div className="area">
                    <h4 className="mini-title">{miniTitle}</h4>
                    <p>{description}</p>
                </div>
                <table className="area">
                    <thead>
                        <tr>
                            <th>
                                <span>{this.props.title}</span>
                            </th>
                            <th className="radio">Coach</th>
                            <th className="radio">Manager</th>
                            <th className="radio">None</th>
                            <th className="empty"></th>
                        </tr>
                    </thead>
                    <tbody>
                        {
                            this.props.entries.map((item) => {
                                let ck = ''
                                if (item.loading) {
                                    ck += ' loading'
                                }

                                if (!item.error) {
                                    return (
                                        <tr key={item.id} className={ck}>
                                            <td className="title">
                                                { item.link && (
                                                    <a href={`#${item.link}`}>
                                                        <span className="long">{item.full_name}</span>
                                                        <span className="short">{item.short_name}</span>
                                                    </a>
                                                )}
                                                { !item.link && (
                                                    <div>
                                                        <span className="long">{item.full_name}</span>
                                                        <span className="short">{item.short_name}</span>
                                                    </div>
                                                )}
                                            </td>
                                            <td className="radio">
                                                {this.getRadioButton(item.is_coach, item.user_id, `coach-${item.user_id}`)}
                                            </td>
                                            <td className="radio">
                                                {this.getRadioButton(item.is_videographer, item.user_id, `manager-${item.user_id}`)}
                                            </td>
                                            <td className="radio">
                                                {this.getRadioButton(!item.is_coach && !item.is_videographer, item.user_id, `none-${item.user_id}`)}
                                            </td>
                                            <td className="empty"></td>
                                        </tr>
                                    )
                                } else {
                                    return (
                                        <tr key={item.id} className={ck}>
                                            <td className="title">
                                                { item.link && (
                                                    <a href={`#${item.link}`}>
                                                        <span className="long">{item.full_name}</span>
                                                        <span className="short">{item.short_name}</span>
                                                    </a>
                                                )}
                                                { !item.link && (
                                                    <div>
                                                        <span className="long">{item.full_name}</span>
                                                        <span className="short">{item.short_name}</span>
                                                    </div>
                                                )}
                                            </td>
                                            <td className="radio" colSpan="3">
                                                <a 
                                                    id={`reset-${item.user_id}`}
                                                    onClick={this.onResetMember}
                                                    className="error"
                                                    href="#failed">
                                                    Please try again.
                                                    &nbsp;
                                                    <span>OK</span>
                                                </a>
                                            </td>
                                            <td className="empty"></td>
                                        </tr>
                                    )
                                }
                            })
                        }
                    </tbody>
                </table>
            </div>
        )
    }

    onGoLink(link) {
        if(link) {
            this.props.history.push(link)
        }
    }
}

const TeamRoleSetter = withRouter(TeamRoleSetterComponent)

export default TeamRoleSetter
